module.exports = __webpack_public_path__ + "media/fall_2024_sweepstakes/instagram-social-icon-1c61f80b.svg";